import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { useLanguage } from '../../context/LanguageContext';

/**
 * Searchable dropdown that also lets the user create a new entry inline
 * when nothing matches (e.g. picking a customer/dealer/device on a repair
 * ticket). `onCreate` must return the id of the newly created record.
 */
const SearchCreateSelect = ({
  options,
  value,
  onChange,
  onCreate,
  placeholder,
  isClearable = true,
  filterOption,
}) => {
  const { t } = useLanguage();
  const selected = options.find((opt) => opt.value === value) || null;

  return (
    <CreatableSelect
      classNamePrefix="react-select"
      options={options}
      value={selected}
      onChange={(opt) => onChange(opt ? opt.value : null)}
      onCreateOption={async (inputValue) => {
        const newId = await onCreate(inputValue);
        if (newId) onChange(newId);
      }}
      isClearable={isClearable}
      filterOption={filterOption}
      placeholder={placeholder ?? t('searchCreateSelect.searchOrCreate')}
      formatCreateLabel={(inputValue) =>
        t('searchCreateSelect.createOption', { value: inputValue })
      }
      styles={{
        control: (base) => ({
          ...base,
          borderRadius: '0.375rem',
          borderColor: '#D1D5DB',
          minHeight: '42px',
        }),
      }}
    />
  );
};

export default SearchCreateSelect;
